<div class="mystery-box-content-list">
  <h4 class="content-label">{{ field.label }}</h4>
  <div *ngIf="hasContent(); else noContent" class="content-items">
    <div *ngFor="let contentItem of getContentItems()" class="content-item">
      <div class="item-section">
        <span class="item-label">Item:</span>
        <a *ngIf="hasLink(contentItem); else noLink" 
           [href]="getItemLink(contentItem)" 
           target="_blank" 
           class="item-name item-link">
          {{ getItemDisplayName(contentItem) }}
        </a>
        <ng-template #noLink>
          <span class="item-name">{{ getItemDisplayName(contentItem) }}</span>
        </ng-template>
      </div>
      <div class="weights-row">
        <div class="weight-section">
          <span class="weight-label">Weight:</span>
          <span class="item-weight">{{ getItemWeight(contentItem) }}</span>
          <span class="item-odds">({{ getNormalizedOdds(contentItem) }})</span>
        </div>
        <div *ngIf="hasSubWeights(contentItem)" class="sub-weights-section">
          <div *ngIf="getCoinWeightName(contentItem)" class="sub-weight-item">
            <span class="sub-weight-label">Coin:</span>
            <span class="sub-weight-value">{{ getCoinWeightName(contentItem) }}</span>
          </div>
          <div *ngIf="getDiamondWeightName(contentItem)" class="sub-weight-item">
            <span class="sub-weight-label">Diamond:</span>
            <span class="sub-weight-value">{{ getDiamondWeightName(contentItem) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noContent>
    <div class="no-content">No content items</div>
  </ng-template>
</div>
